import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@mui/material/Grid';

function ProductEmptyDetailsSection({ theme, t }) {
	return (
		<Grid
			item
			xs={12}
			variant="caption"
			color="textSecondary"
			style={{
				padding: `0 ${theme.spacing(4)} 42% ${theme.spacing(4)}`,
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			{t('no_details_to_show')}
		</Grid>
	);
}

ProductEmptyDetailsSection.propTypes = {
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default ProductEmptyDetailsSection;
